import React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';
import RootineButton from './RootineButton';
import { CustomIcon } from './CustomIcon';

export interface UploadCardProps {
  cardTitle: string;
  icon?: string;
  title: string;
  body: string;
  buttonLabel: string;
  buttonLink?: string;
  buttonFill?: boolean;
  isDisabled?: boolean;
}

export const UploadCard = (props: UploadCardProps): JSX.Element => {
  return (
    <Grid container item xs={12} sx={{ paddingBottom: 10 }}>
      <Grid item xs={12}>
        <Typography
          variant="mono"
          color="text.secondary"
          sx={{
            textAlign: 'left',
            width: '90%',
            fontSize: { xs: 12, sm: 14 },
            position: 'relative',
            top: -10,
          }}
        >
          {props.cardTitle}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ display: 'flex' }}>
          <Paper
            sx={{
              padding: 3,
              borderRadius: 0,
              boxShadow: '0px 1px 16px rgba(137, 137, 137, 0.25)',
              minHeight: 200,
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              sx={{ paddingBottom: 2 }}
            >
              {props.icon && (
                <CustomIcon
                  name={props.icon}
                  sx={{
                    width: 20,
                    height: 20,
                    fill: 'white',
                  }}
                />
              )}
              <Typography
                variant="bold"
                component="h2"
                sx={{ fontSize: 18, marginLeft: 1 }}
              >
                {props.title}
              </Typography>
            </Box>
            <Typography variant="light" component="p">
              {props.body}
            </Typography>
            <Grid container justifyContent="right" sx={{ paddingTop: 10 }}>
              <Grid item xs={0} md={6} />
              <Grid container item xs={12} md={6}>
                <RootineButton
                  label={props.buttonLabel}
                  href={props.buttonLink}
                  fullWidth
                  variation={props.buttonFill ? 'primary' : 'outline_light'}
                  hideIcon
                  size="medium"
                  disabled={props.isDisabled}
                />
              </Grid>
            </Grid>
          </Paper>
        </Box>
      </Grid>
    </Grid>
  );
};
